import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { MATERIAL_ICON_CAMPAIGNS } from '../../../shared/common/Button/Icon';
import { THEME_PRIMARY, THEME_WARNING, themeColor } from '../../../styles/basics/colors';
import MaterialIcon from '../../../shared/common/MaterialIcon';
import { dateFormatToMonthYear } from '../../../shared/utils/utils-string-to-date';
import { useTranslation } from 'react-i18next';

const StBadgeWrapper = styled.div`
    background-color: #f2f9e8;
    padding: 5px;
    border-radius: 2px;
    margin-top: 5px;
    display: inline-block;
`;

const StHeadline = styled.div`
    display: flex;
    flex-direction: row;
    color: ${themeColor(THEME_PRIMARY)} !important;
    line-height: 16px !important;
    font-size: 11px !important;
    margin: 0 !important;
    font-weight: bold;
    padding-bottom: 5px;
`;

const StUsageInfo = styled.div`
    line-height: 16px;
    font-size: 11px;
`;

const StMaterialIcon = styled(MaterialIcon)`
    margin-top: 2px;
    margin-right: 2px;
    vertical-align: text-top;
`;

const StMonth = styled.b<{ isPreOrder: boolean }>`
    color: ${props => (props.isPreOrder ? themeColor(THEME_WARNING) : '')};
`;

interface CampaignUsageBadgeProps {
    loanFormat: string | null;
    usageLimit?: number;
    campaignTerm?: number;
    isSimultaneousAccess?: boolean;
    releaseDate?: number;
    isPreOrder: boolean;
    className?: string;
}

const CampaignUsageBadge = (props: CampaignUsageBadgeProps) => {
    const { t } = useTranslation();
    const {
        loanFormat,
        usageLimit,
        campaignTerm,
        isSimultaneousAccess,
        releaseDate,
        isPreOrder,
        className = ''
    } = props;

    let campaignReleaseDate: ReactNode = null;
    if (releaseDate) {
        campaignReleaseDate = <span>{dateFormatToMonthYear(releaseDate, t)}</span>;
    }
    const simultaneousAccess = isSimultaneousAccess
        ? t('marketing.yourCampaigns.sim')
        : t('marketing.yourCampaigns.ocou');

    const label = t(`marketing.yourCampaigns.campaign_${loanFormat?.toLowerCase()}`);

    return (
        <>
            <StMonth isPreOrder={isPreOrder}>{campaignReleaseDate}</StMonth>
            <br />
            <StBadgeWrapper className={className}>
                <StHeadline>
                    <StMaterialIcon icon={MATERIAL_ICON_CAMPAIGNS} />
                    <div>
                        {label}
                        <br />
                    </div>
                </StHeadline>
                <StUsageInfo>
                    <strong>{simultaneousAccess}</strong> <br />
                    {t('marketing.yourCampaigns.availableLoans')}: <strong>{usageLimit}</strong> <br />
                    {t('marketing.yourCampaigns.campaignLength')}:{' '}
                    <strong>{t('marketing.yourCampaigns.day', { count: campaignTerm })}</strong>
                </StUsageInfo>
            </StBadgeWrapper>
        </>
    );
};

export default CampaignUsageBadge;
